// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"f6636086","98":"b4c9b72c","500":"6807f5a4","891":"b6e9fd41","952":"0c336bb9"}[chunkId] + ".chunk.js";
};